<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
        <vxe-input v-model="query['item.no']" placeholder="business.label.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.name']" placeholder="business.label.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['location.no']" placeholder="business.label.locationNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['container.no']" placeholder="business.label.containerNo" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName"/>
        <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
        <vxe-column field="pack.specification" title="business.label.specification"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="lot.no" title="business.label.lot"/>
        <vxe-column field="batch.no" title="business.label.batchNo"/>
        <vxe-column field="location.no" title="business.label.location"/>
        <vxe-column field="inventory.availableQuantity" title="business.label.availableQuantity"/>
        <vxe-column field="inventory.quantity" title="business.label.quantity"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:inventoryStates}" field="inventory.inventoryState" title="business.label.inventoryStatus" width="100"/>
        <vxe-column field="inventory.availableOutboundQuantity" title="business.label.availableOutboundQuantity"/>
        <vxe-column field="inventory.lockedQuantity" title="business.label.lockedQuantity"/>
        <vxe-column field="log.reasons" title="business.label.lockReasons"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.unlock" icon="vxe-icon-unlock" status="success" @click.stop="unlock(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll, post } from '@/api/Api'
import api from '@/api'

export default {
  name: 'InventoryUnLockingTable',
  props: {
    inventoryStates: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'item.no': '',
        'item.name': '',
        'location.no': '',
        'container.no': '',
        'locked': true
      }
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    back() {
      this.$emit('back')
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('inventoryFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'item.no': '',
        'item.name': '',
        'location.no': '',
        'container.no': '',
        'locked': true
      }
      this.refresh()
    },
    unlock(row) {
      this.loading = true
      const args = {
        inventory: { id: row.inventory.id, availableOutboundQuantity: -row.inventory.lockedQuantity },
        reasons: null,
        'log.id': row.log.id,
        locking: false
      }
      post(api.save, { type: 'inventoryLogPersister' }, args).then(res => {
        if (res.success) {
          this.fetch()
          this.$message.success(this.$t('message.operationSuccess'))
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>